import { findLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// Logo Styles
logoStyles.wrapper = {
    css: css`
        max-height: 110px;
    `,
};

// Note custom CSS is in place via the CMS for the very far top navigation (shipto/signin)
// header styles, logolinkssearch, secondardynavigation, NavigationDrawer - see overridden files

// MainNavigation
mainNavigationStyles.mobileSearchButton = {
    size: 50,
    shape: "rectangle",
    color: "primary",
    css: css`
        padding: 0 10px;
    `,
};

mainNavigationStyles.container = {
    css: css`
        padding: 0 15px;
        display: flex;
        justify-content: left;
        max-width: 1700px;
    `,
};

// SearchInput
searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: {
        src: Search,
        css: css`
            color: ${getColor("secondary.main")};
        `,
    },
    cssOverrides: {
        inputSelect: css`
            border-color: ${getColor("primary.main")};
            border-width: 2px;
            :focus {
                border-color: ${getColor("primary.main")};
            }
            font-size: 18px;
        `,
        formField: css`
            width: 400px;
        `,
    },
};

// SearchHistory
searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 400px;
        padding: 0 20px 15px 20px;
    `,
};

// FindLocationModal (pickup)
findLocationModalStyles.searchGridContainer = {
    gap: 30,
};
